module.exports = __webpack_public_path__ + "static/media/VirtualPBX4.67f7bdcf.JPG";